import React from 'react';
import { Container } from 'react-bootstrap';
import styles from './styles.module.scss';
import TeamToggleButtons from './components/teamToggleButtons';
import CounterpartySection from './counterpartySection';
import DealTeamSection from './dealTeamSection';
import { useNavigation } from '../../../contexts/NavigationContext';

export enum CurrentTeamSidebarTypesEnum {
  counterparty = 'counterparty',
  dealteam = 'dealteam',
}

const DocumentTeamSidebarContainer = () => {
  const { activeParticipantsTab, setActiveParticipantsTab } = useNavigation();

  const currentTeamSidebarType =
    (activeParticipantsTab as CurrentTeamSidebarTypesEnum) || CurrentTeamSidebarTypesEnum.counterparty;

  const setCurrentTeamSidebarType = (tabType: CurrentTeamSidebarTypesEnum) => {
    setActiveParticipantsTab(tabType);
  };

  const renderSidebarSection = () =>
    currentTeamSidebarType === CurrentTeamSidebarTypesEnum.counterparty ? <CounterpartySection /> : <DealTeamSection />;

  return (
    <>
      <Container className={styles.teamSidebarTopToggleContainer}>
        <h2>Participants</h2>
        <TeamToggleButtons
          setCurrentTeamSidebarType={setCurrentTeamSidebarType}
          currentTeamSidebarType={currentTeamSidebarType}
        />
        {renderSidebarSection()}
      </Container>
    </>
  );
};

export default DocumentTeamSidebarContainer;
